import { Component, computed, inject, input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { SplitButton } from 'primeng/splitbutton';
import { ReportRequestDto } from '../../../../api';
import { AuthStore } from '../../../../auth/services/auth.store';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExportFormat } from '../../model/ExportFormat';
import { finalize } from 'rxjs/operators';
import { BlockDocumentUiState } from '../../../../shared/state/block-document-ui.state';
import { MessageService } from '../../../../shared/services/message.service';

@Component({
  selector: 'app-report-actions',
  standalone: true,
  imports: [SplitButton],
  templateUrl: './report-actions.component.html',
})
export class ReportActionsComponent {
  private readonly blockDocumentUiState = inject(BlockDocumentUiState);
  private readonly messageService = inject(MessageService);

  request = input.required<ReportRequestDto>();

  /**
   * Funkcja strategii — przekazywana z zewnątrz.
   * To ona wie jaki endpoint wywołać.
   */
  downloadFn =
    input.required<
      (
        workspaceId: string,
        format: ExportFormat,
        request: ReportRequestDto,
      ) => Observable<HttpResponse<Blob>>
    >();

  private readonly authStore = inject(AuthStore);

  readonly activeWorkspaceId = computed(() => this.authStore.defaultWorkspace()?.id!);

  actions: MenuItem[] = [
    {
      label: 'Pobierz PDF',
      icon: 'pi pi-file-pdf',
      command: () => this.downloadReport('PDF'),
    },
  ];

  downloadReport(format: 'PDF' | 'CSV') {
    this.blockDocumentUiState.setBlocked(true);
    this.downloadFn()(this.activeWorkspaceId()!, format, this.request())
      .pipe(finalize(() => this.blockDocumentUiState.setBlocked(false)))
      .subscribe((response) => {
        this.handleDownload(response);
        this.messageService.showSuccess('Pomyślnie wygenerowano raport.');
      });
  }

  private handleDownload(response: HttpResponse<Blob>) {
    const contentDisposition = response.headers.get('Content-Disposition');
    let fileName = 'report.pdf';

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/);
      if (fileNameMatch?.[1]) {
        fileName = decodeURIComponent(fileNameMatch[1].replace(/"/g, ''));
      }
    }

    const blob = response.body!;
    const urlBlob = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(urlBlob);
  }
}
